<template>
  <div
    v-if="attrs.status === 'uploading'"
    :class="['loading-picture-animation']"
  />
  <img
    v-else-if="!error && attrs.src"
    v-bind="attrs"
    :cross-origin="attrs.crossorigin || 'anonymous'"
    @error="handleError"
  />
  <div v-else-if="error || !attrs.src" :class="['loaded-picture-error']" />
</template>

<script lang="ts" setup>
import { ref, useAttrs } from 'vue'

defineOptions({
  name: 'FallbackImg',
})

const error = ref(false)
const attrs = useAttrs()

const handleError = () => {
  error.value = true
}
</script>
